export type StatusInscricao =
  | 'pendente'
  | 'confirmada'
  | 'isenta'
  | 'lista_espera'
  | 'cancelada';

const CONFIG: Record<StatusInscricao, { label: string; classes: string }> = {
  pendente: { label: 'Aguardando pagamento', classes: 'bg-amber-100 text-amber-800' },
  confirmada: { label: 'Confirmada', classes: 'bg-accent-100 text-accent-900' },
  isenta: { label: 'Isenta', classes: 'bg-accent-100 text-accent-900' },
  lista_espera: { label: 'Na lista de espera', classes: 'bg-secondary-100 text-secondary-700' },
  cancelada: { label: 'Cancelada', classes: 'bg-danger-100 text-danger-700' },
};

interface Props {
  status: StatusInscricao;
}

export default function SeloSituacao({ status }: Props) {
  const config = CONFIG[status] ?? CONFIG.pendente;

  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ${config.classes}`}
    >
      {config.label}
    </span>
  );
}